import { Country } from '@/models/country';

/** Example ranked list for swap announcement illustration. */
export const SWAP_DEMO_COUNTRY_LIST: Country[] = [
  Country.ES,
  Country.GB_ENG,
  Country.DE,
  Country.BR,
  Country.CO,
  Country.NO,
  Country.EC,
  Country.SN,
  Country.CPV,
  Country.BIH,
];

/** 0-based indices pre-checked in the illustration: Germany (#3) and Norway (#6). */
export const SWAP_DEMO_CHECKED_INDICES: readonly [number, number] = [2, 5];
